import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Calendar from "primevue/calendar";


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarBaseInput',
  props: ["modelValue", "disabled", "isInvalid", "minDate"],
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {


const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Calendar), {
    placeholder: "Выберите дату",
    panelClass: "not-extended",
    "model-value": __props.modelValue,
    "aria-describedby": "date-help",
    showIcon: "",
    invalid: __props.isInvalid,
    iconDisplay: "input",
    inputId: "icondisplay",
    disabled: __props.disabled,
    "min-date": __props.minDate,
    selectOtherMonths: true,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = 
        ($event) => {
          emit('update:modelValue', $event)
        }
      )
  }, null, 8, ["model-value", "invalid", "disabled", "min-date"]))
}
}

})